import { render, staticRenderFns } from "./UpdateGMBProfile.vue?vue&type=template&id=e7fa4cbe"
import script from "./UpdateGMBProfile.vue?vue&type=script&lang=js"
export * from "./UpdateGMBProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports